import { List, Map, OrderedSet } from 'immutable';
import { constants as deviceRdcConstants } from '@saucelabs/sl-module-devices-rdc';

import * as constants from './../constants';
import {
  AppRecord,
  AppUploadingRecord,
} from './../records';

const initialState = new Map({
  items: new List(),
  itemsUploading: new Map(),
  loading: true,
  filter: new Map({
    selectedItems: new OrderedSet(),
  }),
});

export const isMobileApp = (app) => {
  if (!app) {
    return false;
  }

  return Object.values(deviceRdcConstants.MOBILE_PLATFORMS).includes(app.platform);
};

const mobileAppsReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case constants.MOBILE_APPS_FETCH.REQUEST:
      return state.set('loading', true);
    case constants.MOBILE_APPS_FETCH.SUCCESS: {
      if (!payload) {
        return state.set('loading', false);
      }
      const items = new List(
        payload.filter(isMobileApp).map((app) => new AppRecord(app)),
      );

      return state
        .set('loading', false)
        .set('items', items);
    }
    case constants.MOBILE_APPS_FETCH.FAILURE:
      return state.set('loading', false);

    case constants.MOBILE_APP_UPLOAD.REQUEST: {
      const displayName = payload.name.trim();

      return state.setIn(
        ['itemsUploading', meta.uploadAppId],
        new AppUploadingRecord({
          id: meta.uploadAppId,
          displayName,
        }),
      );
    }
    case constants.MOBILE_APP_UPLOAD.PROGRESS: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: payload,
        status: constants.APP_UPLOAD_STATUS.UPLOADING,
      });
    }
    case constants.MOBILE_APP_UPLOAD.SUCCESS: {
      return state.withMutations((newState) => newState
        .setIn(
          ['itemsUploading', meta.uploadAppId, 'status'],
          constants.APP_UPLOAD_STATUS.UPLOADED,
        )
        .set(
          'items',
          newState.get('items').unshift(new AppRecord(payload)),
        ),
      );
    }
    case constants.MOBILE_APP_UPLOAD.FAILURE: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        error: constants.APP_UPLOAD_ERROR_MESSAGE,
        status: constants.APP_UPLOAD_STATUS.FAILED,
      });
    }
    case constants.MOBILE_APP_UPLOAD.CANCEL: {
      return state.mergeIn(['itemsUploading', meta.uploadAppId], {
        progress: 0,
        status: constants.APP_UPLOAD_STATUS.CANCELED,
      });
    }

    case constants.SET_FILTER_ITEMS:
      return state.setIn(['filter', 'selectedItems'], payload.items);

    default:
      return state;
  }
};

export default mobileAppsReducer;
export { initialState };
